module.exports = __webpack_public_path__ + "media/components/weather-icon/static/nightmodrain-912c2ae4aafb4d5cd8895da0a465a5f6.webp";